export default "__VITE_ASSET__DMiVYLEc__"